class ScriptComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { ScriptComponentData };
